@if (!isBeta && !isLegacy) {
  <app-login></app-login>
}
<app-active-filter></app-active-filter>

<div id="trade" class="block">
  <div>
    <div class="toast-container toast-bottom-center">
      @if (toastService.toast(); as toast) {
        <div [class]="'toast toast-' + toast.type" style="display: block;" (click)="toastService.dismiss()">
          <div class="toast-progress" [style.animation-duration]="toast.durationMs + 'ms'"></div>
          @if (toast.title) {
            <div class="toast-title">{{ toast.title }}</div>
          }
          <div class="toast-message" [innerHTML]="toast.message"></div>
          @if (toast.footnote) {
            <div class="toast-footnote">{{ toast.footnote }}</div>
          }
        </div>
      }
    </div>
  </div>
  <div class="navigation">
    <ul role="tablist" class="nav nav-tabs main">
      <li role="presentation" class="menu-tab" [class.active]="tabService.currentTab() === 'presets'">
        <a (click)="selectTab('presets')">
          <span class="icon icon-drawer"></span> <span class="menu-tab-text">Presets</span>
        </a>
      </li>
      <li role="presentation" class="menu-tab" [class.active]="tabService.currentTab() === 'quick-filters'">
        <a (click)="selectTab('quick-filters')">
          <span class="icon icon-equalizer"></span> <span class="menu-tab-text">Quick Filters</span>
        </a>
      </li>
      <li role="presentation" class="menu-tab" [class.active]="tabService.currentTab() === 'tier-list'">
        <a (click)="selectTab('tier-list')">
          <span class="icon icon-list-numbered"></span> <span class="menu-tab-text">Tier Lists</span>
        </a>
      </li>
      <li role="presentation" class="menu-tab" [class.active]="tabService.currentTab() === 'custom-rules'">
        <a (click)="selectTab('custom-rules')">
          <span class="icon icon-pencil"></span> <span class="menu-tab-text">Custom Rules</span>
        </a>
      </li>
      <li role="presentation" class="menu-tab" [class.active]="tabService.currentTab() === 'cosmetic'">
        <a (click)="selectTab('cosmetic')">
          <span class="icon icon-paint-format"></span> <span class="menu-tab-text">Cosmetic</span>
        </a>
      </li>
      <li role="presentation" class="menu-tab" [class.active]="tabService.currentTab() === 'preview'">
        <a (click)="selectTab('preview')">
          <span class="icon icon-eye"></span> <span class="menu-tab-text">Preview</span>
        </a>
      </li>
    </ul>

    <ul role="tablist" class="nav nav-tabs account">
      <li role="presentation" class="menu-tab menu-right">
        <app-tooltip-wrapper [contentWidth]="true" [right]="true" style="display: block; cursor: help">
          <a style="display: block; padding: 5px 10px; height: 32px; line-height: 1.45; text-decoration: none !important;">
            <span class="icon icon-question"></span>

            <ng-template #tooltip>
              <app-legend [filter]="storedFilter().filter"></app-legend>
            </ng-template>
          </a>
        </app-tooltip-wrapper>
      </li>
      <li role="presentation" class="menu-tab menu-right" [class.active]="tabService.currentTab() === 'settings'">
        <a (click)="selectTab('settings')">
          <span class="icon icon-cog"></span> <span class="menu-tab-text">Settings</span>
        </a>
      </li>
      @if (poe1 && settings.showExtraTab()) {
        <li role="presentation" class="menu-tab menu-right" [class.active]="tabService.currentTab() === 'extra'">
          <a (click)="selectTab('extra')">
            <span class="icon icon-clipboard"></span> <span class="menu-tab-text">Extra</span>
          </a>
        </li>
      }
      @if (showPendingUpdateMessage) {
        <li role="presentation" class="menu-tab menu-right" [class.update-tab-blink]="settings.ecoUpdateBehaviorUpdateBlink()">
          <a (click)="updateEconomy(true)">
            <span class="icon icon-stats-dots"></span> <span class="menu-tab-text">Update</span>
          </a>
        </li>
      } @else if (showUpdatedMessage) {
        <li role="presentation" class="menu-tab menu-right" [class.update-tab-blink]="updateTabBlinking" [class.update-tab-static]="!updateTabBlinking" [class.active]="tabService.currentTab() === 'updates'">
          <a (click)="selectTab('updates')">
            <span class="icon icon-checkmark"></span> <span class="menu-tab-text" title="Last updated: {{ lastUpdateTimeFormatted }}">{{ lastUpdateTimeFormatted }}</span>
          </a>
        </li>
      } @else {
        <li role="presentation" class="menu-tab menu-right" [class.active]="tabService.currentTab() === 'updates'">
          <a (click)="selectTab('updates')">
            <span class="icon icon-bookmark"></span> <span class="menu-tab-text">Changelog</span>
          </a>
        </li>
      }
      <li role="presentation" class="menu-tab menu-right menu-active-filter">
        <a (click)="openFilterSelector($event)">
          <span class="icon icon-filter"></span> <span class="menu-tab-text">{{ filterService.activeFilterName() }}</span>
        </a>
      </li>
    </ul>
  </div>

  @if (showFilterSelectorDialog) {
    <div class="search-bar" style="padding: 0px !important;">
      <app-filter-selector-dialog
        (close)="showFilterSelectorDialog = false">
      </app-filter-selector-dialog>
    </div>
  }

  <div class="top" [class.floating-controls-active]="showFloatingControls()">
    <div class="search-panel" [class.brown-bg]="tabService.currentTab() === 'presets'">
      <div class="search-bar search-advanced">

        @if (isBeta) {
          <div class="top-bar">
            <strong>This is the beta version of {{ appName }}.</strong> You cannot login & sync nor generate random loot on this site. Visit <a href="{{ domainName }}" target="_blank">{{ displayDomainName }}</a> to use the live version.
          </div>
        }

        @if (isLegacy) {
          <div class="top-bar">
            <strong>This is the legacy version of {{ appName }}.</strong> Use this site to create a filter that still works in {{ leagueName }}, when <a href="{{ domainName }}" target="_blank">{{ displayDomainName }}</a> already supports the next league. You cannot login & sync nor generate random loot on this site.
          </div>
        }

        <!-- <div class="top-bar">
          This weekend, join us in beta testing a huge update to the filter: <a href="https://beta.poe2filter.com/" target="_blank">beta.poe2filter.com</a>. We're eager to hear your feedback on <a href="https://discord.gg/JbaMnwngvq" target="_blank">Discord</a>!
          <div class="close-info-btn" (click)="hideIncomingPatchTopBar()">✕</div>
        </div> -->

        @if (false) {
          <div class="top-bar">
            <!-- Basic <strong>0.5 Return of the Ancients</strong> support done! More info below. Sync disabled until realm is patched. Filter will <strong>not load in 0.4</strong>. <span class="banner-extra-info">Visit <a href="https://legacy.poe2filter.com/" target="_blank">legacy.poe2filter.com</a> to create one that does.</span> -->
            <strong>Alert sounds are back!</strong> 41/42 known uniques added. All uniques prices for League economy updated.
            <div class="close-info-btn" (click)="hideIncomingPatchTopBar()">✕</div>
          </div>
        }
          <!-- <div class="top-bar">
            Basic <strong>3.28 Mirage</strong> support done! More info below. Sync disabled until realm is patched. Filter will <strong>not load in 3.27</strong>. <span class="banner-extra-info">Visit <a href="https://legacy.poe1filter.com/" target="_blank">legacy.poe1filter.com</a> to create one that does.</span>
            <div class="close-info-btn" (click)="hideIncomingPatchTopBar()">✕</div>
          </div> -->
          <!-- <div class="top-bar">
            <strong>Last of the Druids support done</strong>. More info below. Godspeed Exiles! Happy Killing Monsters In A Circle!
            <div class="close-info-btn" (click)="hideIncomingPatchTopBar()">✕</div>
          </div> -->
          <!-- <div class="top-bar">
            Top-tier Gear Base Types are now correctly tiered as Elite. <strong>You should update your filter.</strong> More info on the <a href="/updates">changelog</a> tab.
            <div class="close-info-btn" (click)="hideIncomingPatch030TopBar()">✕</div>
          </div> -->

        @if (showResetWarning) {
          <div class="row row-total row-justify-content-left">
            <div class="info reset-font" style="position: relative;">
              <h2 class="info-title">Oops! Something went wrong and <strong>your stored data needed to be reset</strong>.</h2>
              <p>Because of a critical error, we had to reset all your stored data, including any locally stored filters., Don't worry, <strong>you should still be able to import your filters</strong> back into the tool.</p>
              <ul>
                <li>If you used a downloaded .filter file, import that using the 'Import' button.</li>
                <li>If you synced your filter to your pathofexile.com account, login again, click the 'Change' button in the top-right corner of the page to open the Filter Selector, and download your filter from your account.</li>
              </ul>
              <p>We're terribly sorry for this inconvenience. If the problem persists, please contact us on Discord or the official forum thread, to help us debug the problem and find a fix.</p>
              <p><a class="remove-warning-link" (click)="showResetWarning = false">(I understand and will import my filter again, dismiss)</a></p>
              <div class="close-info-btn" (click)="showResetWarning = false">✕</div>
            </div>
          </div>
        }

        <!-- @if(showCopiesWarning) {
          <div class="row row-total row-justify-content-left">
            <div class="info" style="position: relative;">
              <h2 class="info-title">Heads up! <strong>Counterfeit copies of this website are appearing!</strong></h2>, These illegal copies may not always contain the latest version of the code, may contain bugs, and may even attempt to engage in fraudulent activities., Always only use this official website: poe2filter.com, as referenced in the <a href="https://www.pathofexile.com/forum/view-thread/3630063" target="_blank">official PoE2 forum thread</a>., <a class="remove-warning-link" (click)="hideCopiesWarning()">(I understand, dismiss)</a>
              <div class="close-info-btn" (click)="hideCopiesWarning()">✕</div>
            </div>
          </div>
        } -->

        @if(tabService.currentTab() === 'presets') {
          <app-presets-tab
            [filter]="storedFilter().filter"
            [initialVisit]="initialVisit"
            >
          </app-presets-tab>
        } @if(tabService.currentTab() === 'quick-filters') {
          <app-quick-filter-tab
            [filter]="storedFilter().filter"
            [filterResetWarning]="filterResetWarning"
            [activeRules]="filterResults().activeRules"
            [activeSpecialRules]="filterResults().activeSpecialRules"
            [dynamicWaystoneThresholds]="filterResults().dynamicWaystoneThresholds">
          </app-quick-filter-tab>
        } @else if (tabService.currentTab() === 'cosmetic') {
          <app-cosmetic-tab
            [filter]="storedFilter().filter">
          </app-cosmetic-tab>
        } @else if (tabService.currentTab() === 'custom-rules') {
          <app-custom-rules-tab
            [filter]="storedFilter().filter">
          </app-custom-rules-tab>
          <span class="clear"></span>
          <app-free-rules-tab
            [filter]="storedFilter().filter">
          </app-free-rules-tab>
        }  @else if (tabService.currentTab() === 'tier-list') {
          <app-tier-list-tab
            [filter]="storedFilter().filter">
          </app-tier-list-tab>
        } @else if (tabService.currentTab() === 'settings') {
          <app-settings-tab>
          </app-settings-tab>
        } @else if (tabService.currentTab() === 'updates') {
          <app-changelog-tab [isBeta]="isBeta" [isLegacy]="isLegacy" [initialVisit]="initialVisit"
            [filter]="storedFilter().filter">
          </app-changelog-tab>
        } @else if (tabService.currentTab() === 'preview') {
          <app-preview-tab>
          </app-preview-tab>
        } @else if (tabService.currentTab() === 'extra') {
          <app-extra-tab
            [filter]="storedFilter().filter">
          </app-extra-tab>
        }

        @if (showPresetsDialog) {
          <div class="dialog-backdrop"></div>
          <div class="dialog tutorial center presets-dialog">
            <div class="tutorial-content center-text">
              <div class="tutorial-body">
                @if (showClassPresets) {
                  <p>
                    Select your class.
                  </p>
                  <p>
                    <strong>Warning!</strong> This will change any 'Favourite Gear' rules set by the presets before.
                    <br /><span class="extra-info">It will not change any Cosmetic or Custom Rules.</span>
                  </p>

                  <app-class-presets [filter]="storedFilter().filter"></app-class-presets>
                } @else {
                  <p>
                    Select where you are currently at in the game.
                  </p>
                  <p>
                    <strong>Warning!</strong> This will override your current Quick Filters and possibly change your Tiering Mode.
                    <br /><span class="extra-info">It will not change any Cosmetic or Custom Rules. <br />It will not change any Currency or Unique tiers you've set manually.</span>
                  </p>

                  <app-progress-presets [filter]="storedFilter().filter"></app-progress-presets>
                }

                <div>
                  @if (showClassPresets) {
                    <button type="button" class="btn" (click)="showClassPresets = false">
                      Change Progress
                    </button>
                  } @else {
                    <button type="button" class="btn" (click)="showClassPresets = true">
                      Change Class
                    </button>
                  }
                  <button type="button" class="btn close-tutorial-btn" style="margin-left: 5px" (click)="closePresetsDialog()">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        }

        @if (presetPreviewService.pendingChange()) {
          <app-preset-changes-dialog
            [pendingChange]="presetPreviewService.pendingChange()!"
            (confirm)="onPresetChangeConfirm()"
            (cancel)="onPresetChangeCancel()">
          </app-preset-changes-dialog>
        }

      </div>
      @if (showInlineControls()) {
        <div class="inline-controls-anchor">
          <app-controls
            [showLeft]="true"
            [showCenter]="true"
            [showRight]="true"
            [isBeta]="isBeta"
            [isLegacy]="isLegacy"
            [tab]="tabService.currentTab()"
            [initialVisit]="initialVisit"
            (presetsClick)="showPresetsDialog = true"
            (quickImport)="handleQuickImport($event)"
            (customImport)="handleCustomImport($event)">
          </app-controls>
        </div>
      }

      @if (showFloatingControls()) {
        <div class="controls-floating">
          <app-controls
            [showLeft]="true"
            [showCenter]="true"
            [showRight]="true"
            [isBeta]="isBeta"
            [isLegacy]="isLegacy"
            [tab]="tabService.currentTab()"
            [initialVisit]="initialVisit"
            [floating]="true"
            (presetsClick)="showPresetsDialog = true"
            (quickImport)="handleQuickImport($event)"
            (customImport)="handleCustomImport($event)">
          </app-controls>
        </div>
      }

      @if (showImportDialog) {
        <div class="search-bar" style="padding: 0px !important;">
          <app-import-filter-dialog
            [filterResults]="importFilterResults"
            (close)="closeImportDialog()"
            (updateFilter)="updateFilterSections($event)"></app-import-filter-dialog>
        </div>
      }

    </div>
  </div>

  <div class="clear"></div>
</div>
<div class="clear"></div>

@if (showItemDetails) {
  <div id="trade" class="block">
    @if (parseItemError) {
      <div class="results block">
        <div class="row row-total row-justify-content-left">
          <div class="info">
            <h2 class="info-title">Error parsing item</h2>
            <p><strong>Error:</strong> {{ parseItemError }}</p>
            <div class="item-description">{{ pastedItemText }}</div>
          </div>
        </div>
      </div>
    } @else if (gameItem && simulatorResult) {
      <app-game-item-viewer id="game-item-viewer" [pastedItemText]="pastedItemText" [gameItem]="gameItem" [simulatorResult]="simulatorResult"></app-game-item-viewer>
    }
    <div class="close-info-btn" (click)="showItemDetails = false">✕</div>
  </div>
  <div class="clear"></div>
}

@if(importFilterResults.importFilterError) {
  <div class="results block">
    <div class="row row-total row-justify-content-left">
      <div class="info">
        <h2 class="info-title">Error importing filter</h2>
        <p>Make sure you're importing a filter file which was exported through this tool, and of the correct version: {{ filterVersion }}.</p>
        <p><strong>Error:</strong></p>
        <textarea class="filter-output" style="height: unset; width: 100%;">{{ importFilterResults.importFilterError }}</textarea>
        <div class="close-info-btn" (click)="importFilterResults.importFilterError = null">✕</div>
      </div>
    </div>
  </div>
}

@if(importFilterResults.importFilterSuccess) {
  <div class="results block">
    <div class="row row-total row-justify-content-left">
      <div class="info">
        <h2 class="info-title">Filter imported successfully!</h2>
        <p>Imported filter which was exported on {{ importFilterResults.importFilterExportDate }}.</p>
        @if (importFilterResults.importFilterMigratedFrom) {
          <p>Successfully migrated from v{{ importFilterResults.importFilterMigratedFrom }} to v{{ importFilterResults.importFilterMigratedTo }}</p>
        }
        <div class="close-info-btn" (click)="importFilterResults.importFilterSuccess = false">✕</div>
      </div>
    </div>
  </div>
}

@if (false) {
  <div class="results block">
    <div class="row row-total row-justify-content-left">
      <div class="info reset-font expansion-status">
        <div class="expansion-status-header">
          <img [src]="imgPrefix + '/img/rota-logo.webp'" style="max-width: 100%; height: auto; margin-bottom: 10px;">
        </div>

        <div class="expansion-status-body">
          <h2 class="info-title">Return of the Ancients support status: <strong>Supported</strong>.
            <br />You can start preparing your filter.
            <br />Sync disabled until the Realm is patched and we've done some initial tests.</h2>

          <h3 class="info-title">What's done:</h3>
          <ul>
            <li><strong>✓</strong> Added all new items.</li>
            <li><strong>✓</strong> Renamed and removed items as necessary, migrating your filters.</li>
            <li><strong>✓</strong> Added support for Verisium stacks and the new Rune Item Types.</li>
            <li><strong>✓</strong> Using Preliminary images where available, placeholders otherwise.</li>
            <li><strong>✓</strong> Initial fixed price estimates and tiers configured for all new and changed items.</li>
            <li><strong>✓</strong> All Currency and Uniques values have been reset to their 'Fixed' value, as a frech starting point.</li>
            <li><strong>✓</strong> Item metadata added where already known.</li>
            <li><strong>✓</strong> As a safety measure, any filters migrating to this version will at least show all Uniques until we did a Uniques Economy Update.</li>
            <li><strong>✓</strong> Disabled synchronization until Realm is patched and no issues with the filter are detected.</li>
            <li><strong>✓</strong> Fixed 3 issues with the filter: Verisium Cuffs were renamed to Kalguuran Cuffs, Legacy of Hysseg's Claw was removed, and Expedition Precursor Tablet was removed.</li>
            <li><strong>✓</strong> Successfully validated some test filters against the patched realm. We've re-enabled synchronization.</li>
            <li><strong>✓</strong> Added 274 new Currency & Runes images.</li>
            <li><strong>✓</strong> Added 136 item metadata descriptions, where already available from the game data. More to follow.</li>
            <li><strong>✓</strong> Added metadata, defence types and Tiers for all of the new Gear base types. We might remove them again if they turn out to be unique-only. We might still tweak the Gear Tiers. Remember that most gear stats got tweaked. We'll update all stats later, as soon as they become available.</li>
            <li><strong>✓</strong> Added Kalguuran Skill gem metadata.</li>
            <li><strong>✓</strong> Added the 41/42 currently found and traded Unique items, with their metadata, artwork and initial values.</li>
            <li><strong>✓</strong> Added Voices.</li>

            <!--
            <li><strong>✓</strong> Added Divination Card metadata and artwork.</li>
            <li><strong>✓</strong> Added all Currency metadata.</li>
            <li><strong>✓</strong> Filter loads correctly in-game!</li>
            <li><strong>✓</strong> Added all Currency artwork.</li>
            <li><strong>✓</strong> Added 15 new Uniques with their metadata, images and initial values: Fleshrender, Heroic Tragedy, Khatal's Geyser, Khatal's Weeping, Replica Gifts from Above, Saresh's Darkness, Screams of the Desiccated, Skysunder, Solerai's Radiance, The Bane of Hope, The Broken Elegy, The Desecrated Chalice, The Flame of Hope, The Sacred Chalice, The Sands of Time</li>
            <li><strong>✓</strong> Removed guardrails for League Economy & low-value Uniques. All done!</li> -->

            <!-- <li><strong>✓</strong> Complete metadata & images for all items & currency.</li>
            <li><strong>✓</strong> Correct new Gear Base Type Tiers.</li>
            <li><strong>✓</strong> Initial Currency & Uniques Economy Update done.</li> -->

            <!--
            <li><strong>✓</strong> Item metadata added where already known.</li>
            <li><strong>✓</strong> Using Preliminary images where available, placeholders otherwise.</li>
            <li><strong>✓</strong> Initial price estimates and (SSF) tiers configured.</li>
            <li><strong>✓</strong> Validated that the new filters get parsed correctly.</li>
            <li><strong>✓</strong> Enabled synchronization.</li>
            <li><strong>✓</strong> Added all images.</li>
            <li><strong>✓</strong> Added Currency metadata.</li>
            <li><strong>✓</strong> Adjusted initial Divination Card value estimates.</li>
            <li><strong>✓</strong> Correctly tiered the new Wands and added their Metadata.</li>
            <li><strong>✓</strong> Added all new Uniques with their metadata and values.</li>
            <li><strong>✓</strong> Initial Economy Update for Currency & Cluster Jewels done. You can now use the Market Tiering Modes.</li>
            <li><strong>✓</strong> Initial Uniques Economy Update done.</li>
            <li><strong>✓</strong> Updated Unique Dust Values.</li>
            <li><strong>✓</strong> Updated Class-specific Potential Uniques.</li> -->
          </ul>

          <h3 class="info-title">What happens next:</h3>
          <ul>
            <li><strong>To do</strong>: After a few days: we'll update all modifiers as they become available from the game data.</li>
            <li>Over the coming days, as Currency & Uniques get traded, their values will slowly update automatically.</li>
          </ul>

          <!--
          <h3 class="info-title">Latest news:</h3>
          <ul class="news">
            <li><strong>{{ '2025-09-02T19:35:00+02:00' | date:'dd/MM/yyyy HH:mm' }}</strong> Added all correct images and gear stats.</li>
            <li class="old"><strong>{{ '2025-08-31T16:31:00+02:00' | date:'dd/MM/yyyy HH:mm' }}</strong> Added the first Currency values and corresponding tiering.</li>
            <li class="old"><strong>{{ '2025-08-31T16:31:00+02:00' | date:'dd/MM/yyyy HH:mm' }}</strong> Added all currently known Uniques along with their metadata and values.</li>
            <li class="old"><strong>{{ '2025-08-29T22:08:00+02:00' | date:'dd/MM/yyyy HH:mm' }}</strong> Added preliminary new icons for all new Currency.</li>
            <li class="old"><strong>{{ '2025-08-29T20:46:00+02:00' | date:'dd/MM/yyyy HH:mm' }}</strong> We have re-enabled filter validation against 0.3.0. If you receive an error, please contact us on <a href="https://discord.gg/JbaMnwngvq" target="_blank">Discord</a> or on the <a href="https://www.pathofexile.com/forum/view-thread/3630063/" target="_blank">Official Forum Thread</a> along with your .filter file, so we can investigate.</li>
            <li class="old"><strong>{{ '2025-08-29T20:46:00+02:00' | date:'dd/MM/yyyy HH:mm' }}</strong> It seems two Base Types are not recognized by the game, without mention of GGG. We've temporarily removed the base types and their Uniques from the filter: <strong>Diviner Cuffs</strong> (also the Base Type of the <strong>The Prisoner's Manacles</strong> Unique) and <strong>Coral Circlet</strong> (Only exist as the Base Type of <strong>Crown of Eyes</strong> Unique). We've reported this to GGG and await their response. You will need to re-upload your filter to work.</li>
            <li class="old"><strong>{{ '2025-08-29T12:46:00+02:00' | date:'dd/MM/yyyy HH:mm' }}</strong> We have disabled filter validation against the current game version. <strong>This will allow you to already sync your filter to your account</strong>. We will re-enable validation when the servers start patching, we advise you to re-sync just before the servers go back online.</li>
            <li class="old"><strong>{{ '2025-08-29T20:46:00+02:00' | date:'dd/MM/yyyy HH:mm' }}</strong> We had a few hours down time due to a DNS issue with my hosting provider. <strong>Back up now!</strong></li>
          </ul>

          <h3 class="info-title">What's done:</h3>
          <ul>
            <li><strong>✓</strong> Added or updated all new and changed Currency, Fragments, Omens, Essences, Liquid Emotions, Lineage Gems, Abyssal Eyes and Ancient Bones.</li>
            <li><strong>✓</strong> Added all new Gear Base Types.</li>
            <li><strong>✓</strong> Added support for Exceptional items.</li>
            <li><strong>✓</strong> Removed drop-disabled Uniques items.</li>
            <li><strong>✓</strong> Updated values for all currency based on their value on the in-game Currency Exchange.</li>
            <li><strong>✓</strong> Using new item descriptions.</li>
            <li><strong>✓</strong> All correct icons added.</li>
            <li><strong>✓</strong> All new Gear Base Types stats added.</li>
            <li><strong>To do</strong>: Complete metadata for all currency.</li>
          </ul>
          -->
        </div>

        <p><a class="remove-warning-link" (click)="hideIncomingPatchWarning()">(dismiss)</a></p>
        <div class="close-info-btn" (click)="hideIncomingPatchWarning()">✕</div>
      </div>
    </div>
  </div>
}

<div class="results block output">
  <div class="row row-total">
    <h2 class="info-title text-align-center bigger gradient-title">
      Filter output
    </h2>
    <!-- <button title="Default" class="layout-btn layout-immersion"></button>
    <button title="Compact" class="layout-btn layout-compact"></button>
    <button title="Compact Two-Columned" class="layout-btn layout-compact-two"></button> -->
  </div>

  <div #filterOutput class="filter-output poe-scrollbar" [class.hovering]="ctrlKeyService.isCtrlHeld()" id="filter-output" [innerHTML]="filterOutputService.formattedFilterText()" (click)="onFilterOutputClick($event)"></div>
</div>

<span class="version" (click)="copyVersionToClipboard()">{{ versionDisplayText }}</span>

